export default __webpack_public_path__ + "static/media/calendar-icon.84bab9f5.svg";